module.exports = __webpack_public_path__ + "img/2.1797d5a1.jpg";